import { useState } from "react";
import { Download } from "lucide-react";
import { ExportDialog } from "@/components/export/ExportDialog";

export const ExportMenu = ({ uid, canEdit }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-sm text-[#A8A090] hover:bg-[#13171F] hover:text-[#F3EBDD] transition-colors" data-testid="export-menu-button">
        <Download className="h-4 w-4" />Export
      </button>
      {open && <ExportDialog uid={uid} canEdit={canEdit} onOpenChange={setOpen} />}
    </>
  );
};
